export const MasterPagesMixin = {
    data () {
        return {
            // 削除ダイアログの制御値
            removeOverlay: false,
            // 処理の結果
            process: {
                result: '',
                resultText: '',
                processing: false
            },
            // モーダルの制御値
            dialog: false,
            // 削除時のID
            id: '',
            // エラー
            error: '',
            // v-data-tableのデータ
            desserts: [],
            // 子コンポーネントに渡すデータ
            findData: [],
            // ゴルフグループコード
            golf_group_code: '',
            // 一覧の制御値
            page: 1,
            pageCount: 0,
            limit_rows: 10,
            begin_row: 0
        };
    },
    watch: {
        removeOverlay () {
            if (this.removeOverlay === false) {
                this.process.result = '';
            }
        }
    },
    methods: {
        Initialize () {
            this.id = '';
            this.page = 1;
            this.pageCount = 0;
            this.member_no = '';
            this.removeOverlay = false;
            this.process.result = '';
            this.process.resultText = '';
            this.process.processing = false;
            this.desserts = [];
            this.findData = [];
            this.begin_row = 0;
            this.limit_rows = 10;
        }
    }
};
